module.exports = __webpack_public_path__ + "img/02.ba4f1aef.webp";